import React from 'react';
import { Col } from 'react-bootstrap';

const FormCol3 = (props) => (
  <Col sm={6} lg={3} xl={3} {...props}>
    {props.children}
  </Col>
);

export default FormCol3;

